module.exports = __webpack_public_path__ + "img/device_am35_d_c.a36b31da.png";